import React, { useEffect, useState } from "react";
import { collection, getDocs, doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import '../App.css'; // Assuming you will create this CSS file

const Recordings = () => {
  const [recordings, setRecordings] = useState([]);
  const [userData, setUserData] = useState({});
  const [loading, setLoading] = useState(true);
  const [userLoading, setUserLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  useEffect(() => {
    const fetchRecordings = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "recordings"));
        const fetchedRecordings = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

         fetchedRecordings.sort((a, b) => b.created_at.seconds - a.created_at.seconds);

        setRecordings(fetchedRecordings);
      } catch (error) {
        console.error("Error fetching recordings:", error);
      }
      setLoading(false);
    };

    fetchRecordings();
  }, []);

  useEffect(() => {
    const fetchUserData = async () => {
      const userMap = {};
      const validRecordings = [];
      for (const recording of recordings) {
        if (!userMap[recording.uid]) {
          try {
            const userDoc = await getDoc(doc(db, "users", recording.uid));
            if (userDoc.exists()) {
              userMap[recording.uid] = userDoc.data();
              validRecordings.push(recording);
            }else{
              validRecordings.push(recording);
            }
          } catch (error) {
            console.error("Error fetching user data:", error);
          }
        } else {
          validRecordings.push(recording);
        }
      }
      setUserData(userMap);
      setRecordings(validRecordings);
      setUserLoading(false);
    };

    if (recordings.length > 0) {
      fetchUserData();
    } else {
      setUserLoading(false);
    }
  }, [recordings]);

  const groupedRecordings = recordings.reduce((acc, recording) => {
    const uid = recording.uid;
    if (!acc[uid]) {
      acc[uid] = [];
    }
    acc[uid].push(recording);
    return acc;
  }, {});

  const indexOfLastRecording = currentPage * itemsPerPage;
  const indexOfFirstRecording = indexOfLastRecording - itemsPerPage;
  const currentGroupedRecordings = Object.entries(groupedRecordings).slice(indexOfFirstRecording, indexOfLastRecording);

  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);
  const totalPages = Math.ceil(Object.keys(groupedRecordings).length / itemsPerPage);

  const formatTimestamp = (timestamp) => {
    if (!timestamp) return "Invalid Date";
    const date = new Date(timestamp.seconds * 1000);
    return isNaN(date.getTime()) ? "Invalid Date" : date.toLocaleString();
  };

  return (
    <div className="recordings-container">
      <h1>Recordings</h1>
      {loading || userLoading ? (
        <div className="loading-overlay">
          <div className="spinner"></div>
        </div>
      ) : (
        <>
          <table className="recordings-table">
            <thead>
              <tr>
                <th>User Name</th>
                <th>Email</th>
                <th>Uid</th>
                <th>Recordings</th>
              </tr>
            </thead>
            <tbody>
  {currentGroupedRecordings.map(([uid, recordings]) => {
    const user = userData[uid] || null;  // Set user to null if not found

    return (
      <tr key={uid}>
        <td>
          {user ? user.name : <span>Unknown...</span>} {/* Display loading text or spinner */}
        </td>
        <td>
          {user ? user.email : <span>N/A...</span>} {/* Display loading text or spinner */}
        </td>
        <td>
          {user ? user.uid : <span>Unknown</span>} {/* Display loading text or spinner */}
        </td>
        <td>
      {/* <p className="timestamp">{recordings[0].uid}</p> */}
          {recordings.map((recording) => (
          
           
            <div key={recording.id} className="recording-item">
              <p className="timestamp">{formatTimestamp(recording.created_at)}</p>
              
              <audio controls>
                <source src={recording.url} type="audio/mpeg" />
                Your browser does not support the audio element.
              </audio>
            </div>
          ))}
        </td>
      </tr>
    );
  })}
</tbody>

          </table>

          <div className="pagination-controls">
            <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="pagination-button">
              Prev
            </button>
            <span className="pagination-info">
              Page {currentPage} of {totalPages}
            </span>
            <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className="pagination-button">
              Next
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default Recordings;
